import { VLayout } from '@sleepstation/components-layouts'
import { backgroundColor, marginTop } from '@sleepstation/style-api-helpers'
import { isRunningInBrowser, rem } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { Cookies, withCookies } from 'react-cookie'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout)`
  position: relative;
  min-height: 100vh;
  min-width: ${rem(320)};
  overflow-x: hidden;
  ${backgroundColor(`backgroundStart`)}

  > footer {
    ${marginTop(3.5)}
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Site = ({ children, referrerKeys, domain, cookies, tracking }) => {
  const location = useLocation()

  useEffect(() => {
    if (isRunningInBrowser()) {
      // // Write selected query string key/value pairs to cookies
      // processReferrerKeys(
      //   referrerKeys,
      //   location.href,
      //   domain,
      //   cookies,
      //   tracking
      // )
    }
  }, [cookies, domain, location.href, referrerKeys, tracking])

  return <Layout>{children}</Layout>
}

Site.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  referrerKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  domain: PropTypes.string.isRequired,
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  tracking: PropTypes.object,
}

Site.defaultProps = {
  tracking: null,
}

export default withCookies(Site)
